// pt-BR strings for the Plan 7 'processos' namespace (t('processos.…')), kept apart so each screen's strings live in one file.
export const processosPt = {
  title: 'Processos',
  totals: {
    active_one: '{{count}} ativo',
    active_other: '{{count}} ativos',
    inactive_one: '{{count}} encerrado',
    inactive_other: '{{count}} encerrados',
    area: '{{area}} ha',
    titulares_one: '{{count}} titular',
    titulares_other: '{{count}} titulares',
  },
  exportCsv: 'Exportar .csv',
  exportCsvLabel: 'Exportar a lista filtrada ({{count}} processos) em .csv',
  tabsLabel: 'Processos',
  tabs: {
    minerarios: 'Minerários',
    ambientais: 'Ambientais',
    sei: 'SEI administrativos',
  },
  tabCount: '{{label}} ({{count}})',
  filters: {
    label: 'Filtros',
    phases: 'Fase',
    allPhases: 'Todas',
    substance: 'Substância',
    allSubstances: 'Todas as substâncias',
    municipality: 'Município',
    allMunicipalities: 'Todos os municípios',
    uf: 'UF',
    allUfs: 'Todas as UFs',
    situacao: 'Situação',
    situacoes: { ativos: 'Ativos', encerrados: 'Encerrados', todos: 'Todos' },
    onlyOverdue: 'só com prazo vencido',
    shown_one: '{{count}} processo',
    shown_other: '{{count}} processos',
    clear: 'Limpar filtros',
  },
  vista: { label: 'Visualização', lista: 'Lista', mapa: 'Mapa' },
  columns: {
    processo: 'Processo',
    fase: 'Fase',
    substancia: 'Substância',
    municipios: 'Municípios',
    area: 'Área (ha)',
    proximoPrazo: 'Próximo prazo',
    ultimaMovimentacao: 'Última movimentação',
    modulos: 'Módulos',
  },
  sortBy: 'Ordenar por {{column}}',
  tableLabel: 'Processos minerários',
  empty: 'Nenhum processo com estes filtros.',
  none: 'Nenhum processo dos titulares monitorados.',
  due: {
    overdue: 'vencido {{date}}',
    on: '{{date}}',
    undated: 'sem data',
    days_one: 'em {{count}} dia',
    days_other: 'em {{count}} dias',
  },
  modules: {
    anm: 'ANM',
    ambiental: 'Ambiental',
    ambientalCount_one: 'Ambiental: {{count}} licença',
    ambientalCount_other: 'Ambiental: {{count}} licenças',
    ambientalLocked: 'Ambiental: módulo não contratado',
  },
  inactive: 'encerrado',
  map: {
    label: 'Mapa com as poligonais dos processos filtrados',
    legend: 'Legenda',
    overdue: 'prazo vencido',
    lavra: 'lavra',
    other: 'pesquisa e demais fases',
    listTitle_one: '{{count}} no mapa',
    listTitle_other: '{{count}} no mapa',
    loading: 'Carregando as poligonais…',
    failed: 'Não foi possível carregar as poligonais agora. A lista continua ao lado.',
    noShape: 'sem poligonal no SIGMINE',
    missing_one: '{{count}} processo sem poligonal no SIGMINE',
    missing_other: '{{count}} processos sem poligonal no SIGMINE',
    ha: '{{area}} ha',
  },
  csv: {
    processo: 'Processo',
    fase: 'Fase',
    substancias: 'Substâncias',
    municipios: 'Municípios',
    uf: 'UF',
    area: 'Área (ha)',
    situacao: 'Situação',
    ativo: 'Ativo',
    encerrado: 'Encerrado',
    proximoPrazo: 'Próximo prazo',
    oQueFazer: 'O que fazer',
    prazosVencidos: 'Prazos vencidos',
    prazosAbertos: 'Prazos em aberto',
    ultimaMovimentacao: 'Última movimentação',
    file: 'processos-{{date}}.csv',
  },
  ambientais: {
    lockedTitle: 'Licenciamento ambiental',
    locked: 'As licenças e os pedidos dos titulares nos órgãos ambientais (IAT-PR, IMA-SC, IBAMA): disponível com o módulo Ambiental.',
    filtersLabel: 'Filtrar licenças',
    filters: {
      todas: 'Todas',
      vencidas: 'Com prazo vencido',
      fora: 'Fora dos processos',
      minhas: 'Cadastradas por mim',
    },
    filterCount: '{{label}} ({{count}})',
    addLicence: '+ Cadastrar licença',
    addRequest: '+ Acompanhar pedido',
    howTitleLicence: 'Cadastrar uma licença',
    howTitleRequest: 'Acompanhar um pedido',
    howBody: 'Licenças e pedidos são cadastrados no processo a que se referem, na aba Ambiental. Escolha o processo:',
    pickProcess: 'Processo',
    pickPlaceholder: 'Escolha um processo',
    open: 'Abrir a aba Ambiental do processo',
    close: 'Fechar',
    licences: 'Licenças ({{count}})',
    requests: 'Pedidos em andamento ({{count}})',
    noLicences: 'Nenhuma licença com este filtro.',
    noRequests: 'Nenhum pedido em andamento.',
    licencesLabel: 'Licenças ambientais',
    requestsLabel: 'Pedidos em andamento',
    columns: {
      licenca: 'Licença',
      orgao: 'Órgão',
      processo: 'Processo ANM',
      atividade: 'Atividade',
      emitida: 'Emitida',
      validade: 'Validade',
      prazo: 'Prazo',
      protocolo: 'Protocolo',
      origem: 'Origem',
      situacao: 'Situação',
      ondeEsta: 'Onde está',
    },
    licence: 'Licença',
    outside: 'fora dos processos',
    manual: 'cadastrada por você',
    confirmed: 'confirmada por você',
    delisted: 'deixou de constar em {{date}}',
    origin: {
      licence: 'da própria licença',
      attached: 'apensado pelo órgão',
      listed: 'listado pelo órgão',
      manual: 'acompanhado por você',
    },
    missing: 'número não encontrado',
    notChecked: '1ª consulta em breve',
    since: 'desde {{date}}',
    ended: 'Encerrados ({{count}})',
    endedLabel: 'Pedidos encerrados',
    openRequest: 'Abrir no e-Protocolo ↗',
    stopFollowing: 'Deixar de acompanhar',
    remove: 'Remover',
    removeError: 'Não foi possível remover. Tente de novo.',
  },
} as const;
